import React from "react"
import BackgroundImage from "../components/background-images"
import SEO from "../components/seo"
import { useTranslation } from "react-i18next"
import Footer from "../components/footer"
import Header from "../components/header"

const datapolicy = () => {
  const { i18n } = useTranslation()
  console.log(i18n.language)
  return (
    <BackgroundImage>
      <SEO title="Datapolicy" />
      <Header />
      <div className="container">
        <div id="privacy">{i18n.language === "de" ? DE : EN}</div>
      </div>
      <Footer />
    </BackgroundImage>
  )
}

export default datapolicy

const EN = (
  <div>
    <h1>Privacy policy</h1>
    <p>
      Privacy policy of FOLO GmbH
      <br />
      FOLO GmbH (hereafter 'Folo' or 'We' or 'Us') is pleased with your interest
      in our company, our services and your visit to our website.
      <br />
    </p>
    <ol>
      <h4>
        <li>Folo protects your privacy</li>
      </h4>
      <p>
        It is important to us to protect your personal information. The data we
        collect when you visit our website is processed confidentially and only
        in accordance with the law. <br />
        Privacy, security and privacy are fundamental to our corporate policy.{" "}
        <br />
        Data-protection, security and privacy are fundamental to our corporate
        policy.
      </p>
      <h4>
        <li>Person responsibility</li>
      </h4>
      <p>
        Responsible for the processing of your data: <br />
      </p>
      <p>
        FOLO GmbH <br />
        Rotlintstraße 45
        <br />
        60316 Frankfurt
        <br />
        E-mail: hello@foloaround.com <br />
        Phone: +49 15206318626 <br />
      </p>
      <p>
        To assert your rights and to report data protection incidents, please
        contact the above E-mail address. If you have any suggestions and / or
        complaints regarding the processing of your personal data, please do not
        hesitate to contact us.
      </p>
      <h4>
        <li>Processing of personal data</li>
      </h4>
      <h5>3.1 Processed data categories</h5>
      <p>
        We process your communication data (such as name, telephone number,
        e-mail address, address, IP address)
      </p>
      <h5>3.2 Processing principles</h5>
      <p>
        Personal information is any information that relates to an identified or
        identifiable natural person; a natural person is considered to be
        identifiable, directly or indirectly, in particular by means of
        Assignment to an identifier such as a name, an identification number,
        location data, an online identifier, or one or more special features.{" "}
        <br />
        We, as well as service providers commissioned by us, process your
        personal data for the following purposes:
      </p>
      <h5>3.3 Processing purposes and legal bases</h5>
      <p>
        We, as well as service providers commissioned by us, process your
        personal data for the following purposes:
      </p>
      <p>
        3.3.1 Provision of the online offer
        <br />
        Legal basis: Legitimate interest on our part to present ourselves
        publicly and to show our services.
      </p>
      <p>
        3.3.2 Answering user requests by means of common communication channels
        <br />
        Legal basis: Legitimate interest on our part to get in touch with
        interested parties and customers. In addition, to improve our products
        and services and marketing activities, as long as this is in accordance
        with legal requirements.
      </p>
      <p>
        3.3.3 Determination (Investigation?) of faults and for security reasons
        <br />
        Legal basis: Fulfillment of our legal obligations and legitimate
        interest in the safety of our Offers and to eliminate interference.
      </p>
      <p>
        3.3.4 Own and third-party advertising
        <br />
        Legal basis: By consent or legitimate interest on our part.
      </p>
      <p>
        3.3.5 Upholding our rights
        <br />
        Legal basis: legitimate interest on our part.
      </p>
      <h5>3.4 Log-files</h5>
      <p>
        When using the Internet, data will be automatically transmitted by you.
        The data you send to us to transfer, are stored by us in log files.
      </p>
      <p>
        In particular, the following information is stored in the log files.
      </p>
      <p>
        • IP address (Internet Protocol address) of the terminal from which the
        online offering is accessed
        <br />• Internet address of the website from which the online offer was
        called (so-called origin or Referrer URL)
        <br />• Name of the service provider used to access the online offer
        <br />• Name of the retrieved files or information
        <br />• Date and time as well as the duration of the call
        <br />• Transferred amount of data
        <br />• Operating system and information about the Internet browser
        used, including installed add-ons
        <br />• http status code (for example, 'request succeeded' or 'requested
        file not found')
      </p>
      <p>
        The log files are used by us to identify faults and for security reasons
        (e.g. for the clarification of Attempted attacks), stored for a short
        period and then deleted. Log files whose further retention is required,
        are exempt from the deletion until the final clarification of the
        incident and may in individual cases be passed on to investigative
        authorities.
      </p>
      <p>
        Log files are used (without or without full IP address) Log files are
        used (with either partial or no IP address) OR Log files are used (with
        partial or without IP address) under the conditions of Section 3.3.4
        'Own and third-party advertising as well as market research and range
        measurement to the legally permissible extent or consent-based' and also
        for analysis purposes.
      </p>
      <h5>3.5 Disclosure of data</h5>
      <p>
        3.5.1 Transfer of data to other persons responsible
        <br />
        Your personal data will only be communicated by us to other persons
        responsible, insofar as this is necessary for the fulfillment of the
        contract, or if we or the third party have an overriding legitimate
        interest in the disclosure or if your consent exists.
      </p>
      <p>
        In addition, data may be transmitted to other persons responsible, as
        long as there are legally liable provisions, or we should be obliged to
        do so by enforceable administrative or court order.
      </p>
      <p>
        3.5.2 Transfer of data to service providers
        <br />
        We commission external service providers with tasks such as data
        hosting. The service providers are carefully selected and used by us for
        confidentiality and obligation to comply with legal requirements.
      </p>
      <p>
        3.5.3 Transfer to recipients outside the European Economic Area (EEA)
        <br />
        We may also transfer personal information to recipients located outside
        the EEA in so-called third countries. In this case, before the passing
        on, we ensure that the recipient has either an adequate level of data
        protection (e.g. based on a decision on the adequacy of the EU
        Commission for the respective country or countries) agreement of
        so-called EU standard contractual clauses of the European Union with the
        recipient or your consent to disclosure.
      </p>
      <h5>3.6 Duration of storage and retention periods</h5>
      <p id="cookies">
        As a matter of principle, we store your data for as long as this is
        necessary for the provision of our online offer and that connected
        services are required, or we have a legitimate interest in the further
        storage. We delete your personal data other than information that we
        need to retain in order to fulfill our legal obligations (For example,
        due to tax and commercial retention periods, we are required to submit
        documents such as contracts and invoices for a certain period of time).
      </p>
      <h4>
        <li>Use of cookies</li>
      </h4>
      <p>
        Cookies serve to make our offer more user-friendly, effective and
        secure. Cookies are small Text files that are stored on your computer
        and stored by your browser.
      </p>
      <h5>4.1 Categories of cookies</h5>
      <p>
        Most of the cookies we use are so-called 'session cookies'. They will be
        automatically deleted after your visit. Other cookies remain stored on
        your device until you delete them. These cookies allow us to recognize
        your browser on your next visit.
      </p>
      <h5>4.2 Third party cookies via external links</h5>
      <p>
        When using external content via www.Folo.io e.g. in the case of a link,
        third-party cookies may be used without our explicit reference.
      </p>
      <h5>4.3 Disable cookies</h5>
      <p>
        If you want to disable all cookies, then please go to your browser
        settings and deactivate the setting of cookies. Please note that this
        may affect the functionality of the website.
      </p>

      <h4>
        <li>External links</li>
      </h4>
      <p>
        Our online offer may contain links to third party websites - providers
        not affiliated with us. After clicking on the link, we no longer have
        any influence on the collection, processing and use of any personal data
        transmitted by clicking on the link to the third party (such as the IP
        address or the URL of the page on which the link is located) because the
        behavior of third parties is naturally beyond our control. We are not
        responsible for the processing of such personal data by third parties.
      </p>
      <h4>
        <li>Security</li>
      </h4>
      <p>
        Our employees and our service providers commissioned by us are bound by
        confidentiality and compliance with the regulations committed to
        applicable data protection laws.
      </p>
      <p>
        We take all necessary technical and organizational measures to ensure an
        adequate level of protection of your Data managed by us, especially
        against the risks of unintentional or unlawful destruction,
        Manipulation, loss, Change or unauthorized disclosure or unauthorized
        access. Our security measures are constantly being improved in line with
        technological developments.
      </p>
      <h4>
        <li>Your rights</li>
      </h4>
      <p>
        Please use the information in the section 'Responsible body and contact'
        to assert your rights. (see no. 2). Please make sure that we can clearly
        identify you.
      </p>
      <h5>9.1 Information law and access right</h5>
      <p>
        You have the right to receive information about the processing of your
        data from us. You can do this by claiming a Right to information in
        relation to the personal information we process about you.
      </p>
      <h5>9.2 Right to rectification and erasure</h5>
      <p>
        You can correct the wrong data and - as far as the legal requirements
        are met - completion or delete your data.
      </p>
      <p>
        This does not apply to data that is required for billing and accounting
        purposes or the statutory retention requirements subject. As far as
        access to such data is not needed, but their processing restricted (see
        below).
      </p>
      <h5>9.3 Restriction of processing</h5>
      <p>
        As far as the legal requirements are met, you can demand that we
        restrict processing of your data.
      </p>
      <h5>9.4 Data portability</h5>
      <p>
        You also have the right to receive data provided to us in a structured,
        common and machine-readable format or, if technically feasible, to
        request that the data be transmitted to a third party.
      </p>
      <h5>9.5 Right of objection</h5>
      <p>
        9.5.1 Individual right of objection
        <br />
        Unless we have processing of data based on a predominant legitimate
        interest, as this Privacy policy set out to make, you have the right at
        any time, for reasons that arise from your particular situation to
        object against this Processing.
      </p>
      <p>
        We will then stop processing your data, unless we can - in accordance
        with the law Specifications – prove legitimate, worthy reasons for
        further processing that outweigh your interests, rights and freedoms, or
        the Further processing serves the assertion, exercise or defense of
        legal claims.
      </p>
      <p>
        9.5.2 Objection to the processing of data for advertising purposes
        <br />
        You may also at any time object to the processing of your personal
        information for advertising purposes ('Advertising Objection'). Please
        take into account, that for organizational reasons, if there is an
        overlap between the use of your data and your objection, your data may
        still be visible in the context of an ongoing campaign.
      </p>
      <h5>9.6 Cancellation right</h5>
      <p>
        If you have given us consent to the processing of your data, you can
        withdraw them at any time with effect for the future.
      </p>
      <h5>9.7 Right of appeal to the supervisory authority</h5>
      <p>
        You have the right to file a complaint with a data protection
        supervisory authority. You can contact the responsible Hessian
        commissioners for data protection and freedom of information. <br />
        <a href="https://datenschutz.hessen.de/">
          https://datenschutz.hessen.de/
        </a>
      </p>
    </ol>
    <h4>Change of privacy policy</h4>
    <p>
      We reserve the right to change our security and privacy practices to the
      extent necessary for technical Development. In these cases, we will also
      adjust our privacy policy to comply. Please note that only the current
      version of our privacy policy is valid.
    </p>
    <p>Updated 2020.11.25</p>
  </div>
)

const DE = (
  <div>
    <h1>Datenschutzerklärung</h1>
    <p>
      Verantwortlicher im Sinne der Datenschutzgesetze, insbesondere der
      EU-Datenschutzgrundverordnung (DSGVO), ist:
    </p>
    <p>
      The Doorman Betriebsgesellschaft mbH ist eine Gesellschaft mit
      beschränkter Haftung gemäß der Rechtsprechung der Bundesrepublik
      Deutschland.
    </p>
    <p>
      <br />
      Geschäftsführer: Nermin Grosch
      <br />
      <br />
      Company headquarters: Stephanstraße 1 / 60313 Frankfurt am Main / Germany
      <br />
      Fon: +49 (69) 697619 00
      <br />
      Fax: +49 (69) 697619 10
      <br />
      Web: www.thedoorman.de
      <br />
      E-Mail: info@thedoorman.de
    </p>
    <h2>Ihre Betroffenenrechte</h2>
    <p>
      Unter den angegebenen Kontaktdaten unseres Datenschutzbeauftragten können
      Sie jederzeit folgende Rechte ausüben:
    </p>
    <ul>
      <li>
        Auskunft über Ihre bei uns gespeicherten Daten und deren Verarbeitung
        (Art. 15 DSGVO),
      </li>
      <li>Berichtigung unrichtiger personenbezogener Daten (Art. 16 DSGVO),</li>
      <li>Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO),</li>
      <li>
        Einschränkung der Datenverarbeitung, sofern wir Ihre Daten aufgrund
        gesetzlicher Pflichten noch nicht löschen dürfen (Art. 18 DSGVO),
      </li>
      <li>
        Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art. 21 DSGVO)
        und
      </li>
      <li>
        Datenübertragbarkeit, sofern Sie in die Datenverarbeitung eingewilligt
        haben oder einen Vertrag mit uns abgeschlossen haben (Art. 20 DSGVO).
      </li>
    </ul>
    <p>
      Sofern Sie uns eine Einwilligung erteilt haben, können Sie diese jederzeit
      mit Wirkung für die Zukunft widerrufen.
    </p>
    <p>
      Sie können sich jederzeit mit einer Beschwerde an eine Aufsichtsbehörde
      wenden, z. B. an die zuständige Aufsichtsbehörde des Bundeslands Ihres
      Wohnsitzes oder an die für uns als verantwortliche Stelle zuständige
      Behörde.
    </p>
    <p>
      Eine Liste der Aufsichtsbehörden (für den nichtöffentlichen Bereich) mit
      Anschrift finden Sie unter:{" "}
      <a
        href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
        target="_blank"
        rel="nofollow noopener"
      >
        https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html
      </a>
      .
    </p>
    <p>
      {" "}
      Im Falle der Speicherung der Daten in Logfiles ist dies nach spätestens 14
      Tagen der Fall. Eine darüberhinausgehende Speicherung ist möglich. In
      diesem Fall werden die IP-Adressen der Nutzer anonymisiert, sodass eine
      Zuordnung des aufrufenden Clients nicht mehr möglich ist.
    </p>
    <h2>Kontaktformular</h2>
    <h3>Art und Zweck der Verarbeitung:</h3>
    <p>
      Die von Ihnen eingegebenen Daten werden zum Zweck der individuellen
      Kommunikation mit Ihnen gespeichert. Hierfür ist die Angabe einer validen
      E-Mail-Adresse sowie Ihres Namens erforderlich. Diese dient der Zuordnung
      der Anfrage und der anschließenden Beantwortung derselben. Die Angabe
      weiterer Daten ist optional.
    </p>
    <h3>Rechtsgrundlage:</h3>
    <p>
      Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt auf
      der Grundlage eines berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO).
    </p>
    <p>
      Durch Bereitstellung des Kontaktformulars möchten wir Ihnen eine
      unkomplizierte Kontaktaufnahme ermöglichen. Ihre gemachten Angaben werden
      zum Zwecke der Bearbeitung der Anfrage sowie für mögliche Anschlussfragen
      gespeichert.
    </p>
    <p>
      Sofern Sie mit uns Kontakt aufnehmen, um ein Angebot zu erfragen, erfolgt
      die Verarbeitung der in das Kontaktformular eingegebenen Daten zur
      Durchführung vorvertraglicher Maßnahmen (Art. 6 Abs. 1 lit. b DSGVO).
    </p>
    <h3>Empfänger:</h3>
    <p>Empfänger der Daten sind ggf. Auftragsverarbeiter.</p>
    <h3>Speicherdauer:</h3>
    <p>
      Daten werden spätestens 6 Monate nach Bearbeitung der Anfrage gelöscht.
    </p>
    <p>
      Sofern es zu einem Vertragsverhältnis kommt, unterliegen wir den
      gesetzlichen Aufbewahrungsfristen nach HGB und löschen Ihre Daten nach
      Ablauf dieser Fristen.{" "}
    </p>
    <h3>Bereitstellung vorgeschrieben oder erforderlich:</h3>
    <p>
      Die Bereitstellung Ihrer personenbezogenen Daten erfolgt freiwillig. Wir
      können Ihre Anfrage jedoch nur bearbeiten, sofern Sie uns Ihren Namen,
      Ihre E-Mail-Adresse und den Grund der Anfrage mitteilen.
    </p>
    <h2>Verwendung von Google Maps</h2>
    <p>
      Auf dieser Website nutzen wir das Angebot von Google Maps. Google Maps
      wird von Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043,
      USA (nachfolgend „Google“) betrieben. Dadurch können wir Ihnen interaktive
      Karten direkt in der Webseite anzeigen und ermöglichen Ihnen die
      komfortable Nutzung der Karten-Funktion.
      <br />
      Nähere Informationen über die Datenverarbeitung durch Google können Sie
      den Google-Datenschutzhinweisen entnehmen:{" "}
      <a
        href="https://policies.google.com/privacy"
        rel="noopener nofollow"
        target="_blank"
      >
        https://policies.google.com/privacy
      </a>
      . Dort können Sie im Datenschutzcenter auch Ihre persönlichen
      Datenschutz-Einstellungen verändern.
    </p>
    <p>
      Ausführliche Anleitungen zur Verwaltung der eigenen Daten im Zusammenhang
      mit Google-Produkten finden Sie hier:{" "}
      <a
        href="https://www.dataliberation.org/"
        rel="noopener nofollow"
        target="_blank"
      >
        https://www.dataliberation.org
      </a>
    </p>
    <p>
      Durch den Besuch der Website erhält Google Informationen, dass Sie die
      entsprechende Unterseite unserer Webseite aufgerufen haben. Dies erfolgt
      unabhängig davon, ob Google ein Nutzerkonto bereitstellt, über das Sie
      eingeloggt sind, oder ob keine Nutzerkonto besteht. Wenn Sie bei Google
      eingeloggt sind, werden Ihre Daten direkt Ihrem Konto zugeordnet.{" "}
    </p>
    <p>
      Wenn Sie die Zuordnung in Ihrem Profil bei Google nicht wünschen, müssen
      Sie sich vor Aktivierung des Buttons bei Google ausloggen. Google
      speichert Ihre Daten als Nutzungsprofile und nutzt sie für Zwecke der
      Werbung, Marktforschung und/oder bedarfsgerechter Gestaltung seiner
      Websites. Eine solche Auswertung erfolgt insbesondere (selbst für nicht
      eingeloggte Nutzer) zur Erbringung bedarfsgerechter Werbung und um andere
      Nutzer des sozialen Netzwerks über Ihre Aktivitäten auf unserer Website zu
      informieren. Ihnen steht ein Widerspruchsrecht zu gegen die Bildung dieser
      Nutzerprofile, wobei Sie sich zur Ausübung dessen an Google richten
      müssen.{" "}
    </p>
    <h3>Widerruf der Einwilligung:</h3>
    <p>
      Vom Anbieter wird derzeit keine Möglichkeit für einen einfachen Opt-out
      oder ein Blockieren der Datenübertragung angeboten. Wenn Sie eine
      Nachverfolgung Ihrer Aktivitäten auf unserer Website verhindern wollen,
      widerrufen Sie bitte im Cookie-Consent-Tool Ihre Einwilligung für die
      entsprechende Cookie-Kategorie oder alle technisch nicht notwendigen
      Cookies und Datenübertragungen. In diesem Fall können Sie unsere Website
      jedoch ggfs. nicht oder nur eingeschränkt nutzen.
    </p>
    <h2>SSL-Verschlüsselung</h2>
    <p>
      Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden
      wir dem aktuellen Stand der Technik entsprechende
      Verschlüsselungsverfahren (z. B. SSL) über HTTPS.
    </p>
    <hr />
    <h2>Information über Ihr Widerspruchsrecht nach Art. 21 DSGVO</h2>
    <h3>Einzelfallbezogenes Widerspruchsrecht</h3>
    <p>
      Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation
      ergeben, jederzeit gegen die Verarbeitung Sie betreffender
      personenbezogener Daten, die aufgrund Art. 6 Abs. 1 lit. f DSGVO
      (Datenverarbeitung auf der Grundlage einer Interessenabwägung) erfolgt,
      Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmung
      gestütztes Profiling im Sinne von Art. 4 Nr. 4 DSGVO.
    </p>
    <p>
      Legen Sie Widerspruch ein, werden wir Ihre personenbezogenen Daten nicht
      mehr verarbeiten, es sei denn, wir können zwingende schutzwürdige Gründe
      für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und
      Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung,
      Ausübung oder Verteidigung von Rechtsansprüchen.
    </p>
    <h3>Empfänger eines Widerspruchs</h3>
    <p>
      Company headquarters: Stephanstraße 1 / 60313 Frankfurt am Main / Germany
      <br />
      Fon: +49 (69) 697619 00
      <br />
      Fax: +49 (69) 697619 10
      <br />
      Web: www.thedoorman.de
      <br />
      E-Mail: info@thedoorman.de
    </p>
    <hr />
    <h2>Änderung unserer Datenschutzbestimmungen</h2>
    <p>
      Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie
      stets den aktuellen rechtlichen Anforderungen entspricht oder um
      Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z.B.
      bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die
      neue Datenschutzerklärung.
    </p>
    <h2>Fragen an den Datenschutzbeauftragten</h2>
    <p>
      Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail
      oder wenden Sie sich direkt an die für den Datenschutz verantwortliche
      Person in unserer Organisation:
    </p>
  </div>
)
